export const PLUS_BANNER_OFFER_MODULE = 'Plus Banner Offer';
